<template>
    <div class="app flex-row align-items-center">
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="8">
            <b-card-group>
              <b-card no-body class="p-4" >
                <div slot="header">
                  <strong>Cambio password</strong>
                </div>
                <b-form-group>
                  <label for="newPassword">Nuova password</label>
                  <b-form-input v-model="newPassword" type="password" id="newPassword" placeholder></b-form-input>
                  <b-form-invalid-feedback
                    :force-show="errors.newPassword"
                  >La password deve essere lunga almeno 8 caratteri e deve contenere almeno 1 carattere minuscolo, 1 carattere maiuscolo, 1 numero e un carattere speciale</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group>
                  <label for="newPasswordConfirmation">Conferma password</label>
                  <b-form-input
                    v-model="newPasswordConfirmation"
                    type="password"
                    id="newPasswordConfirmation"
                    placeholder
                  ></b-form-input>
                  <b-form-invalid-feedback
                    :force-show="errors.newPasswordConfirmation"
                  >Le password devono corrispondere</b-form-invalid-feedback>
                </b-form-group>
                <div slot="footer">
                  <b-button :disabled="loading" type="submit" @click="changePwd" variant="primary">
                    <i v-if="loading" class="fa fa-spinner fa-pulse fa-fw"></i>
                    <i v-else class="fa fa-lock"></i> Cambia
                  </b-button>
                  <span v-if="success" class="text-success">&nbsp;Password cambiata con successo!</span>
                  <span
                    v-if="errors.submit"
                    class="text-danger"
                  >&nbsp;Errore durante il cambio password, password attuale errata</span>
                </div>
              </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "ChangeForgotPassword",
  data() {
    return {
      errors: {
        newPassword: false,
        newPasswordConfirmation: false,
        submit: false
      },
      success: false,
      loading: false,
      newPassword: "",
      newPasswordConfirmation: "",
      token: this.$route.query.token
    };
  },
  computed: {

  },
  methods: {
    changePwd: function() {
      if (!this.checkForm()) {
        return;
      }

      this.loading = true;
      this.$store
        .dispatch("changepwd", {
          newPassword: this.newPassword,
          token: this.token
        })
        .then(() => {
          this.newPassword = "";
          this.newPasswordConfirmation = "";
          this.success = true;

          alert("Password modificata con successo, verrai adesso reindirizzato sulla pagina di Login");
          this.$router.push('/')
        })
        .catch(err => {
          console.log("error");
          this.errors.submit = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    checkForm: function() {
      const strongRegex = new RegExp(
        "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_])(?=.{8,})"
      );

      this.success = false;
      this.errors.submit = false;

      if (!this.newPassword || !strongRegex.test(this.newPassword)) {
        this.errors.newPassword = true;
        return false;
      } else {
        this.errors.newPassword = false;
      }

      if (this.newPassword != this.newPasswordConfirmation) {
        this.errors.newPasswordConfirmation = true;
        return false;
      } else {
        this.errors.newPasswordConfirmation = false;
      }

      return true;
    }
  }
};
</script>
